// extracted by mini-css-extract-plugin
export var active = "styles-module--active--Xuc-Q";
export var button = "styles-module--button--gaZgU";
export var buttonIcon = "styles-module--buttonIcon--h48IU";
export var closeInfoButton = "styles-module--closeInfoButton--kypHR";
export var closeInfoButtonContainer = "styles-module--closeInfoButtonContainer--hWOAl";
export var container = "styles-module--container--25d+F";
export var content = "styles-module--content--ociST";
export var imageContainer = "styles-module--imageContainer---hgX0";
export var infoButtonIcon = "styles-module--infoButtonIcon--7Up8t";
export var infoContainer = "styles-module--infoContainer--bNz87";
export var showInfoButton = "styles-module--showInfoButton---X3aU";